import { TipoEvento } from './datalayer.types';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const imprimirLog = (params: { tipoEvento: TipoEvento; dados: any }) => {
  const auraDatalayerLog = localStorage.getItem('auraDatalayerLog');

  if (params.tipoEvento === 'page' && auraDatalayerLog === 'page') {
    // eslint-disable-next-line no-console
    console.log('[DataLayer Log - page]', params.dados);
  }
  if (params.tipoEvento === 'event' && auraDatalayerLog === 'event') {
    // eslint-disable-next-line no-console
    console.log('[DataLayer Log - event]', params.dados);
  }

  if (auraDatalayerLog === 'all') {
    // eslint-disable-next-line no-console
    console.log('[DataLayer Log - all]', params.dados);
  }
};
